import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';
import { CommitteeMeetingAttendeeDto } from './dto/committee-meeting-attendee.dto';

@Injectable({
  providedIn: 'root',
})
export class CommitteeMeetingAttendeeService {
  constructor(private _apiService: ApiService) {}

  get(id: number) {
    return this._apiService.get(`CommitteeMeetingAttendee/${id}`);
  }

  create(dto: CommitteeMeetingAttendeeDto) {
    return this._apiService.post('CommitteeMeetingAttendees', dto);
  }

  update(dto: CommitteeMeetingAttendeeDto) {
    return this._apiService.put(`CommitteeMeetingAttendee/${dto.AttendeeID}`, dto);
  }

  delete(id: number) {
    return this._apiService.delete(`CommitteeMeetingAttendee/${id}`);
  }
}
